import logo from '@assets/atg-loading-new-logo-23.gif';
import { Box, Grid, Typography } from '@atgfr8/atg-ui-tailwind';
import {
  fetchLtlQuoteTerminals,
  LtlTerminalInfoViewModel,
} from '@store/orders';
import { createSignal, onMount, Show } from 'solid-js';

import TerminalDestinationCard from './components/TerminalDestinationCard';

export const ViewTerminalPopover = (props: {
  terminalInfo: LtlTerminalInfoViewModel;
  quoteId: string;
}) => {
  const [terminalInfo, setTerminalInfo] =
    createSignal<LtlTerminalInfoViewModel | null>(null);

  onMount(async () => {
    const result = await fetchLtlQuoteTerminals(String(props.quoteId));
    setTerminalInfo(result);
  });

  return (
    <Show
      when={terminalInfo()}
      fallback={
        <Box class="min-w-[600px] flex justify-center items-center p-8">
          <img src={logo} alt="Loading..." />
        </Box>
      }
    >
      <Box class="min-w-[600px]">
        <Typography variant="h4" class="text-center">
          Terminal Info
        </Typography>

        <Grid container spacing={4} class="p-4">
          <Grid item size={6}>
            <Typography variant="h6">Origin</Typography>
            <TerminalDestinationCard
              address1={terminalInfo()?.pickupTerminal?.address1}
              address2={terminalInfo()?.pickupTerminal?.address2}
              city={terminalInfo()?.pickupTerminal?.city}
              state={terminalInfo()?.pickupTerminal?.state}
              postalCode={terminalInfo()?.pickupTerminal?.postalCode}
              countryCode={terminalInfo()?.pickupTerminal?.countryCode}
              contactPhone={terminalInfo()?.pickupTerminal?.contactPhone}
              contactName={terminalInfo()?.pickupTerminal?.contactName}
              contactTollFree={terminalInfo()?.pickupTerminal?.contactTollFree}
              contactFax={terminalInfo()?.pickupTerminal?.contactFax}
              contactEmail={terminalInfo()?.pickupTerminal?.contactEmail}
              terminalName={terminalInfo()?.pickupTerminal?.terminalName}
            />
          </Grid>
          <Grid item size={6}>
            <Typography variant="h6">Destination</Typography>
            <TerminalDestinationCard
              address1={terminalInfo()?.deliveryTerminal?.address1}
              address2={terminalInfo()?.deliveryTerminal?.address2}
              city={terminalInfo()?.deliveryTerminal?.city}
              state={terminalInfo()?.deliveryTerminal?.state}
              postalCode={terminalInfo()?.deliveryTerminal?.postalCode}
              countryCode={terminalInfo()?.deliveryTerminal?.countryCode}
              contactPhone={terminalInfo()?.deliveryTerminal?.contactPhone}
              contactName={terminalInfo()?.deliveryTerminal?.contactName}
              contactTollFree={
                terminalInfo()?.deliveryTerminal?.contactTollFree
              }
              contactFax={terminalInfo()?.deliveryTerminal?.contactFax}
              contactEmail={terminalInfo()?.deliveryTerminal?.contactEmail}
              terminalName={terminalInfo()?.deliveryTerminal?.terminalName}
            />
          </Grid>
        </Grid>
      </Box>
    </Show>
  );
};
